<template>
  <CalendarField
    :label="t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.endTime')"
    :placeholder="
      t(
        'sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.endTimePlaceholder',
      )
    "
    :id="`tender-end-time-${index}`"
    :inputId="`tender-end-time-${index}`"
    :name="fieldName"
    timeOnly
    hourFormat="12"
    :stepMinute="15"
    :required="true"
    :baseZIndex="9999"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Set localization
const { t } = useI18n();
</script>
